import _ from 'lodash'
import { getEnv } from './helpers'
import { isApiFetchError } from './type-guards'

export const handleError = (error: any): { code: string; message?: string } => {
  switch (error.name) {
    case 'TypeError':
      if (error.message === 'Failed to fetch') return { code: 'NetworkError' }
      return { code: 'UnknownError' }
    default:
      return { code: _.get(error, 'name', 'UnknownError'), message: _.get(error, 'message') }
  }
}

export const getApiErrorMessage = (error: unknown, defaultMessage: string = 'An error occurred') => {
  return isApiFetchError(error) && getEnv('NODE_ENV') !== 'production' ? error.data.messages.join('\n') : defaultMessage
}
